import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

const FILE_REQUEST_ROUTING_PARAMS = {
  fileRequestId: 'fileRequestId',
};

export class FileRequestPaths {
  static fileRequest = new EnhancedPath('/file-request');

  static fileRequestManagement = new EnhancedPath(
    `${FileRequestPaths.fileRequest.path}/:${FILE_REQUEST_ROUTING_PARAMS.fileRequestId}?`,
  );
}

const routesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: FileRequestPaths.fileRequestManagement.path,
      component: lazyWithRetry(() => import('app/pages/documents/fileRequest')),
      pageCode: PAGE_CODES.FILE_REQUEST,
      skipPermissionCheck: true,
    },
  ],
};

export default routesConfig;
